/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import momentPropTypes from 'react-moment-proptypes';
import { forbidExtraProps } from 'airbnb-prop-types';
import moment from 'moment';
import omit from 'lodash/omit';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import isInclusivelyAfterDay from 'react-dates/lib/utils/isInclusivelyAfterDay';
import isInclusivelyBeforeDay from 'react-dates/lib/utils/isInclusivelyBeforeDay';

import { DayPickerRangeController, ScrollableOrientationShape } from 'react-dates';
import { START_DATE, END_DATE, VERTICAL_ORIENTATION } from 'react-dates/src/constants';

import styles from './DayPickerRangeControllerWrapper.module.css';

const propTypes = forbidExtraProps({
  // example props for the demo
  autoFocusEndDate: PropTypes.bool,
  initialStartDate: momentPropTypes.momentObj,
  initialEndDate: momentPropTypes.momentObj,
  startDateOffset: PropTypes.func,
  endDateOffset: PropTypes.func,
  showInputs: PropTypes.bool,

  keepOpenOnDateSelect: PropTypes.bool,
  minimumNights: PropTypes.number,
  isOutsideRange: PropTypes.func,
  isDayBlocked: PropTypes.func,
  isDayHighlighted: PropTypes.func,

  // DayPicker props
  enableOutsideDays: PropTypes.bool,
  numberOfMonths: PropTypes.number,
  orientation: PropTypes.string,
  verticalHeight: PropTypes.number,
  withPortal: PropTypes.bool,
  initialVisibleMonth: PropTypes.func,
  renderCalendarInfo: PropTypes.func,
  renderMonthElement: PropTypes.func,
  renderMonthText: PropTypes.func,

  navPrev: PropTypes.node,
  navNext: PropTypes.node,

  onPrevMonthClick: PropTypes.func,
  onNextMonthClick: PropTypes.func,
  onOutsideClick: PropTypes.func,
  renderCalendarDay: PropTypes.func,
  renderDayContents: PropTypes.func,

  // i18n
  monthFormat: PropTypes.string,

  isRTL: PropTypes.bool,

  onDateChange: PropTypes.func,
  startDate: momentPropTypes.momentObj,
  endDate: momentPropTypes.momentObj,
});

const defaultProps = {
  // example props for the demo
  autoFocusEndDate: false,
  initialStartDate: null,
  initialEndDate: null,
  startDateOffset: undefined,
  endDateOffset: undefined,
  showInputs: false,

  // day presentation and interaction related props
  renderCalendarDay: undefined,
  renderDayContents: function(day){
    return (
      <div>
        {day.format('D')}
        <span>$229</span>
      </div>
    );
  },
  minimumNights: 1,
  isDayBlocked: () => false,
  isOutsideRange: day => !isInclusivelyAfterDay(day, moment()),
  isDayHighlighted: () => false,
  enableOutsideDays: false,

  // calendar presentation and interaction related props
  orientation: VERTICAL_ORIENTATION,
  verticalHeight: undefined,
  withPortal: false,
  initialVisibleMonth: null,
  numberOfMonths: 2,
  onOutsideClick() {},
  keepOpenOnDateSelect: false,
  renderCalendarInfo: null,
  isRTL: false,

  // navigation related props
  navPrev: null,
  navNext: null,
  onPrevMonthClick() {},
  onNextMonthClick() {},

  // internationalization
  monthFormat: 'MMMM',
};

class DayPickerRangeControllerWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      focusedInput: props.autoFocusEndDate ? END_DATE : START_DATE,
      startDate: props.initialStartDate,
      endDate: props.initialEndDate,
      price: 229
    };

    this.onDatesChange = this.onDatesChange.bind(this);
    this.onFocusChange = this.onFocusChange.bind(this);
    this.isDayHighlighted = this.isDayHighlightedFactory()
  }

  isDayHighlightedFactory() {
    return (day: any) => (
      isInclusivelyBeforeDay(day, moment(this.state.startDate).add(-1, 'days')) &&
      !isInclusivelyBeforeDay(day, moment(this.state.startDate).add(-1, 'days').diff())
    );
  }

  componentWillReceiveProps(newProps) {
    if (this.props.endDateOffset !== newProps.endDateOffset) {
      this.setState({
        startDate: newProps.initialStartDate,
        endDate: newProps.initialEndDate,
      });
    } else {
      this.setState({
        startDate: newProps.startDate,
        endDate: newProps.endDate,
      })
    }
  }

  onDatesChange({ startDate, endDate }) {
    this.setState({ startDate, endDate });
    this.setState({ startDate }, () => {
      this.isDayHighlighted = this.isDayHighlightedFactory();
    });
    this.setState({ price: !endDate ? 240 : 180 })
    if(this.props.onDateChange) this.props.onDateChange({ startDate, endDate });
  }

  onFocusChange(focusedInput) {
    this.setState({
      // Force the focusedInput to always be truthy so that dates are always selectable
      focusedInput: !focusedInput ? START_DATE : focusedInput,
    });
  }

  render() {
    const { showInputs } = this.props;
    const { focusedInput, startDate, endDate } = this.state;

    const props = omit(this.props, [
      'autoFocus',
      'autoFocusEndDate',
      'initialStartDate',
      'initialEndDate',
      'showInputs',
      'onDateChange',
    ]);

    const startDateString = startDate && startDate.format('YYYY-MM-DD');
    const endDateString = endDate && endDate.format('YYYY-MM-DD');

    const renderPriceSpan = (day) => {
      
      const calendarDay = day.format('D');
      const startDate = this.state.startDate ? new Date(this.state.startDate).getUTCDate() : null;
      const endDate = this.state.endDate ? new Date(this.state.endDate).getUTCDate() : null

      if(startDate && endDate) {
        if(calendarDay > endDate) {
          return <span></span>
        } else {
          if(calendarDay == endDate) {
            return <span>${this.state.price}</span>
          } else {
            return <span></span>
          }
        }
      } else {
        return(
          <span>${this.state.price}</span>
        )
      }
    }

    return (
      <div className="dayPickerRangeControllerWrapper" style={{ height: '100%' }}>
        {showInputs &&
          <div style={{ marginBottom: 16 }}>
            <input type="text" name="start date" value={startDateString} readOnly />
            <input type="text" name="end date" value={endDateString} readOnly />
          </div>
        }

        <DayPickerRangeController
          {...props}
          renderDayContents={(day) => {
            return (
              <div className={(this.state.startDate && !this.state.endDate && new Date(this.state.startDate).getUTCDate() == day.format('D')) ? styles.firstDateSelected : ''}>
                {day.format('D')}
                {renderPriceSpan(day)}
              </div>
            );
          }}
          onDatesChange={this.onDatesChange}
          onFocusChange={this.onFocusChange}
          focusedInput={focusedInput}
          startDate={startDate}
          endDate={endDate}
          isDayHighlighted={this.isDayHighlighted}
        />
      </div>
    );
  }
}

DayPickerRangeControllerWrapper.propTypes = propTypes;
DayPickerRangeControllerWrapper.defaultProps = defaultProps;

export default DayPickerRangeControllerWrapper;



// WEBPACK FOOTER //
// ./src/components/DayPickerRangeControllerWrapper/DayPickerRangeControllerWrapper.jsx